import { render } from "./SmartComponent.vue?vue&type=template&id=593f0f00&ts=true"
import script from "./SmartComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmartComponent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/SmartComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "593f0f00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('593f0f00', __exports__)) {
    api.reload('593f0f00', __exports__)
  }
  
  module.hot.accept("./SmartComponent.vue?vue&type=template&id=593f0f00&ts=true", () => {
    api.rerender('593f0f00', render)
  })

}


export default __exports__